import { TableLazyLoadEvent } from 'primeng/table';
import { Filter } from '../models/filter';
import { Sorter } from '../models/sorter';
import { TableState } from 'src/app/@core/services/table-state.service';

/**
 * Convertit un TableLazyLoadEvent de PrimeNG en paramètres d'URL OData
 * @param event L'événement de chargement lazy de PrimeNG
 * @returns L'URL complète avec les paramètres OData
 */
export function tableLazyLoadEventToUrl(event: TableLazyLoadEvent): string {
    let url = '';
    let hasOptions = false;

    // Gestion du tri ($orderby)
    if (event.sortField) {
        const sorters: Sorter[] = [];

        if (Array.isArray(event.sortField)) {
            // Multi-sort
            for (let i = 0; i < event.sortField.length; i++) {
                const sortOrder = Array.isArray(event.sortOrder) ? event.sortOrder[i] : event.sortOrder;
                sorters.push(new Sorter({
                    property: event.sortField[i],
                    descending: sortOrder === -1
                }));
            }
        } else {
            // Single sort
            sorters.push(new Sorter({
                property: event.sortField,
                descending: event.sortOrder === -1
            }));
        }

        if (sorters.length > 0) {
            url += hasOptions ? '&' : '?';
            url += Sorter.toUrlString(sorters);
            hasOptions = true;
        }
    }

    // Gestion de la pagination ($skip et $top)
    if (typeof event.first === 'number') {
        url += hasOptions ? '&' : '?';
        url += '$skip=' + event.first;
        hasOptions = true;
    }

    if (typeof event.rows === 'number') {
        url += hasOptions ? '&' : '?';
        url += '$top=' + event.rows;
        hasOptions = true;
    }

    return url;
}

/**
 * Convertit un TableState en paramètres d'URL OData
 * @param event L'état du tableau que l'on souhaite convertir
 * @returns L'URL complète avec les paramètres OData
 */
export function tableStateToUrl(state: TableState): string {
    let url = '';
    let hasOptions = false;

    // Gestion du tri ($orderby)
    if (state.sortField) {
        const sorters: Sorter[] = [];

        if (Array.isArray(state.sortField)) {
            // Multi-sort
            for (let i = 0; i < state.sortField.length; i++) {
                const sortOrder = Array.isArray(state.sortOrder) ? state.sortOrder[i] : state.sortOrder;
                sorters.push(new Sorter({
                    property: state.sortField[i],
                    descending: sortOrder === -1
                }));
            }
        } else {
            // Single sort
            sorters.push(new Sorter({
                property: state.sortField,
                descending: state.sortOrder === -1
            }));
        }

        if (sorters.length > 0) {
            url += hasOptions ? '&' : '?';
            url += Sorter.toUrlString(sorters);
            hasOptions = true;
        }
    }

    // Gestion de la pagination ($skip et $top)
    if (typeof state.first === 'number') {
        url += hasOptions ? '&' : '?';
        url += '$skip=' + state.first;
        hasOptions = true;
    }

    if (typeof state.rows === 'number') {
        url += hasOptions ? '&' : '?';
        url += '$top=' + state.rows;
        hasOptions = true;
    }

    return url;
}
